<template>
  <van-row justify="center" class="page-wrapper">
    <van-col span="24" class="itserve-center">
      <template v-if="meterageZone !== null">
        <send-indications-info-part />
        <div
          class="send-indications-content bottom-content-grow flex-display-fix"
        >
          <div class="place-content-center">
            <flashlight />
            <h5 class="count-zones apply-loader">
              {{ $t("regionalEnergy.sendIndications.zone" + meterageZone) }}
            </h5>
            <!-- <van-col span="24" class="mt-25">
              <van-switch
                active-color="#4CD964"
                inactive-color="#777777"
                v-model="photoMode"
              />
            </van-col> -->
            <template v-if="meterageZone === 1">
              <template v-if="windowWidth >= 340">
                <single-zone-standart />
              </template>
              <template v-else>
                <single-zone-small />
              </template>
            </template>
            <template v-else>
              <template v-if="windowWidth >= 340">
                <multi-zone-standart />
              </template>
              <template v-else>
                <multi-zone-small />
              </template>
            </template>
            <div class="donora-good-action-wrap">
              <button
                class="donora-good-action apply-loader"
                type="button"
                @click="openDonora"
              >
                <span class="donora-good-content">
                  <span class="donora-good-heart" aria-hidden="true">
                    <svg viewBox="0 0 64 64">
                      <path
                        d="M32 52S10 39 10 23c0-7 5-12 12-12 4 0 8 2 10 6 2-4 6-6 10-6 7 0 12 5 12 12 0 16-22 29-22 29Z"
                      />
                    </svg>
                  </span>
                  <span>{{ $t("donora.goodDeedButton") }}</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </van-col>
  </van-row>
</template>

<script>
import "vue-awesome/icons/history";
import "vue-awesome/icons/paper-plane";

import SingleZoneStandart from "@/components/indications/SingleZoneStandart";
import MultiZoneStandart from "@/components/indications/MultiZoneStandart";
import SendIndicationsInfoPart from "@/components/indications/SendIndicationsInfoPart";
import Flashlight from "@/components/indications/Flashlight";
import SingleZoneSmall from "@/components/indications/SingleZoneSmall";
import MultiZoneSmall from "@/components/indications/MultiZoneSmall";
import Donora from "@/plugins/api/factories/Donora";
//import Switch  from "vant/lib/switch/index";

const DONORA_LINK =
  "https://donora.help/app?utm_source=zhytomyr_energo&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=energy";

export default {
  name: "SendIndications",
  components: {
    // VanSwitch: Switch,
    MultiZoneSmall,
    SingleZoneSmall,
    Flashlight,
    SendIndicationsInfoPart,
    MultiZoneStandart,
    SingleZoneStandart,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    // photoMode: {
    //   get() {
    //     return this.$store.state.RegionalEnergy.sendPhoto;
    //   },
    //   set(photoMode) {
    //     this.$store.commit("RegionalEnergy/SET_PHOTO_MODE", photoMode);
    //   },
    // },
    meterageZone() {
      console.log(
        "meterageZone: " + this.$store.state.RegionalEnergy.meterage_zone
      );
      return this.$store.state.RegionalEnergy.meterage_zone;
    },
    errorMessage() {
      return this.$store.state.Api.errors.message;
    },
    account() {
      return this.$store.state.Auth.account;
    },
  },
  created() {
    this.$store.dispatch(
      "RegionalEnergy/getLastIndications",
      this.$route.params.account
    );
    window.addEventListener("resize", this.changeWidthOfWindow);
  },
  destroyed() {
    window.removeEventListener("resize", this.changeWidthOfWindow);
  },
  methods: {
    async openDonora() {
      const link = DONORA_LINK;

      try {
        await Donora.link(this.getDonoraPayload(link));
      } catch (error) {
        console.error("Donora link tracking error:", error);
      } finally {
        this.openExternalUrl(link);
      }
    },
    getDonoraPayload(link) {
      return {
        account_number: this.account
          ? this.account.ls
          : this.$route.params.account,
        address: this.getAccountAddress(),
        link,
      };
    },
    getAccountAddress() {
      if (!this.account) {
        return "";
      }

      const addressParts = [
        this.account.streetType,
        this.account.streetName,
        this.account.building,
        this.account.appartment
          ? `${this.$t("components.accounts.apartment")} ${
              this.account.appartment
            }`
          : "",
        this.account.city,
      ];

      return addressParts.filter(Boolean).join(", ");
    },
    openExternalUrl(url) {
      if (typeof this.nativeSendEvent === "function") {
        this.nativeSendEvent("url", url);
        return;
      }

      window.open(url, "_blank", "noopener");
    },
    switchMode() {
      this.$store.commit("RegionalEnergy/SET_PHOTO_MODE");
    },
    changeWidthOfWindow() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>
<style scoped>
@import "../../../../node_modules/vant/lib/dialog/index.css";
@import "../../../../node_modules/vant/lib/overlay/index.css";
@import "../../../../node_modules/vant/lib/popup/index.css";
@import "../../../../node_modules/vant/lib/switch/index.css";

.count-zones {
  display: inline-block;
  border: 1px solid #c4c4c4;
  padding: 5px 28px 5px 28px;
  border-radius: 5px;
}
h5 {
  color: #0b0b0b;
  padding: 0;
  text-align: center;
  font-size: 18px;
  margin: 0;
}

.donora-good-action-wrap {
  clear: both;
  padding-top: 25px;
}

.donora-good-action {
  display: block;
  width: 100%;
  max-width: 337px;
  height: 50px;
  margin: 0 auto 20px;
  border: 0;
  padding: 0;
  border-radius: 12px;
  background: #4477f6;
  color: #ffffff;
  cursor: pointer;
  font-family: inherit;
  box-shadow: none;
  outline-offset: 3px;
  transition: transform 0.16s ease, filter 0.16s ease;
}

.donora-good-action:active {
  transform: translateY(1px);
}

.donora-good-content {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
}

.donora-good-heart {
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  animation: donora-good-heart-pulse 1.35s ease-in-out infinite;
}

.donora-good-heart svg {
  width: 25px;
  height: 25px;
  display: block;
  fill: none;
  stroke: #ffffff;
  stroke-width: 5;
  stroke-linejoin: round;
}

@keyframes donora-good-heart-pulse {
  0%,
  100% {
    transform: scale(1);
  }

  48% {
    transform: scale(1.13);
  }
}

.send-indications-content :deep(.send-indications-table) {
  width: 337px;
  max-width: calc(100% - 24px);
  margin: 18px auto 20px;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  border: 0 !important;
  box-shadow: none !important;
}

.send-indications-content :deep(.send-indications-table tbody),
.send-indications-content :deep(.send-indications-table tr),
.send-indications-content :deep(.send-indications-table th),
.send-indications-content :deep(.send-indications-table td) {
  border: 0 !important;
  box-shadow: none !important;
  background-image: none !important;
}

.send-indications-content :deep(.send-indications-table th) {
  padding: 0 6px 12px;
  color: rgba(255, 255, 255, 0.74) !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  text-decoration: none !important;
}

.send-indications-content :deep(.send-indications-table th::before),
.send-indications-content :deep(.send-indications-table th::after) {
  display: none !important;
}

.send-indications-content :deep(.send-indications-table td) {
  width: 50%;
  padding: 0 8px;
  color: #ffffff !important;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  vertical-align: middle;
}

.send-indications-content :deep(.prev-ind-wrapper) {
  height: 42px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}

.send-indications-content :deep(.itserve-input) {
  margin: 0;
}

.send-indications-content :deep(.input-wrapper) {
  padding-top: 0;
}

.send-indications-content :deep(.itserve-input-field) {
  height: 42px;
  max-width: 100%;
  padding: 0 10px !important;
  border: 1px solid rgba(132, 157, 190, 0.55);
  border-radius: 10px;
  background-color: #060b11;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
}

.send-indications-content :deep(.itserve-input-field:focus) {
  border-color: #4477f6 !important;
  background-color: #060b11 !important;
}

.send-indications-content :deep(.itserve-input-field::placeholder) {
  color: rgba(255, 255, 255, 0.78);
  font-size: 11px !important;
  font-weight: 700;
}

.send-indications-content :deep(.itserve-label) {
  display: none;
}

@media (max-width: 340px) {
  .donora-good-action {
    max-width: 300px;
  }

  .donora-good-content {
    gap: 10px;
    font-size: 16px;
  }

  .donora-good-heart,
  .donora-good-heart svg {
    width: 23px;
    height: 23px;
  }

  .send-indications-content :deep(.send-indications-table th) {
    font-size: 13px;
  }
}
</style>
<style>
.send-indications-content .send-indications-table {
  width: 337px !important;
  max-width: calc(100% - 24px) !important;
  margin: 18px auto 20px !important;
  border: 0 !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  box-shadow: none !important;
}

.send-indications-content .send-indications-table tbody,
.send-indications-content .send-indications-table tr,
.send-indications-content .send-indications-table th,
.send-indications-content .send-indications-table td {
  border: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  background-image: none !important;
}

.send-indications-content .send-indications-table th {
  padding: 0 6px 12px !important;
  color: rgba(255, 255, 255, 0.74) !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 1.2 !important;
  text-align: center !important;
}

.send-indications-content .send-indications-table td {
  width: 50% !important;
  padding: 0 8px !important;
  vertical-align: middle !important;
}

.send-indications-content .prev-ind-wrapper {
  height: 42px !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #ffffff !important;
  font-size: 16px !important;
  font-weight: 700 !important;
}

.send-indications-content .itserve-input,
.send-indications-content .size-small {
  margin: 0 !important;
}

.send-indications-content .input-wrapper {
  padding-top: 0 !important;
}

.send-indications-content .itserve-input-field,
.send-indications-content .size-small input {
  width: 100% !important;
  height: 42px !important;
  max-width: 100% !important;
  padding: 0 10px !important;
  border: 1px solid rgba(132, 157, 190, 0.55) !important;
  border-radius: 10px !important;
  background: #060b11 !important;
  color: #ffffff !important;
  box-shadow: none !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-align: center !important;
  box-sizing: border-box !important;
}

.send-indications-content .itserve-input-field:focus,
.send-indications-content .size-small input:focus {
  border-color: #4477f6 !important;
  background: #060b11 !important;
}

.send-indications-content .itserve-input-field::placeholder,
.send-indications-content .size-small input::placeholder {
  color: rgba(255, 255, 255, 0.78) !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-align: center !important;
}

.send-indications-content .itserve-label {
  display: none !important;
}
</style>
